import type {ReactElement} from 'react'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import Filter from '@freckle/school/ts/manage-teachers/components/filter'
import type {TeacherTabFilteringT} from './'

type Props = {
  currentSchoolIds: Array<number> | undefined | null
  teacherTabFilter: TeacherTabFilteringT | undefined | null
}

export default function TeacherTabFilter(props: Props): ReactElement | null {
  const {teacherTabFilter, currentSchoolIds} = props

  if (teacherTabFilter === null || teacherTabFilter === undefined) {
    return null
  }

  const url = Routes.dashboard({
    schoolIds: currentSchoolIds,
    activeTab: 'teacher-tab',
  })

  const {course, student} = teacherTabFilter

  if (course !== undefined) {
    const name = `Teachers of ${course.name}`
    return <Filter name={name} url={url} />
  }

  if (student !== undefined) {
    const name = `Teachers of ${student.name}`
    return <Filter name={name} url={url} />
  }

  return null
}
